exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

require('./domEnhance');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//获取函数的函数名, 为了兼容IE8
function functionName(fun) {
    var ret = fun.toString();
    ret = ret.substr('function '.length);
    ret = ret.substr(0, ret.indexOf('('));
    return ret;
}

var Sloth = function () {
    function Sloth() {
        _classCallCheck(this, Sloth);

        this.selector = "component";
        this.components = [];
    }

    Sloth.prototype.init = function init() {
        var _this = this;

        $('[' + this.selector + ']').each(function (index, dom) {
            var moduleName = $(dom).attr(_this.selector);
            var Component = _this.getComponent(moduleName);

            if (_typeof(dom.component) === 'object') return; //防止重复初始化组件
            if (!Component) return; //未找到对应组件

            var instance = new Component();
            instance.dom = dom;
            instance.options = Object.assign({}, Component.defaultOptions, $(dom).options());
            instance.onInit();
            dom.component = instance;
        });
    };

    // Decorator


    Sloth.prototype.component = function component(options) {
        var _this2 = this;

        return function (component) {
            component.defaultOptions = options.defaultOptions;
            _this2.addComponent(component);
        };
    };

    Sloth.prototype.addComponent = function addComponent(component) {
        component.componentName = functionName(component);
        this.components.push(component);
    };

    Sloth.prototype.getComponent = function getComponent(componentName) {
        for (var i = 0; i < this.components.length; i++) {
            if (this.components[i].componentName === componentName) return this.components[i];
        }
    };

    Sloth.prototype.removeComponent = function removeComponent(componentName) {
        for (var i = 0; i < this.components.length; i++) {
            if (this.components[i].componentName === componentName) this.components.splice(i, 1);
        }
    };

    return Sloth;
}();

exports.default = new Sloth();


/*****************
 ** WEBPACK FOOTER
 ** ./~/slothd/dist/Sloth/sloth.js
 ** module id = 1
 ** module chunks = 0
 **/